import { SUITS, SUIT_NAMES, WINDS, WIND_NAMES, DRAGONS, DRAGON_NAMES } from './constants.js';

export function makeTile(type, suit, num, honor, id) {
  return { type, suit: suit || null, num: num || 0, honor: honor || null, id: id || 0 };
}

export function createDeck() {
  const d = [];
  let id = 0;
  for (const s of SUITS) for (let n = 1; n <= 9; n++) for (let c = 0; c < 4; c++) d.push(makeTile('suited', s, n, null, id++));
  for (const w of WINDS) for (let c = 0; c < 4; c++) d.push(makeTile('wind', null, 0, w, id++));
  for (const dr of DRAGONS) for (let c = 0; c < 4; c++) d.push(makeTile('dragon', null, 0, dr, id++));
  for (let c = 0; c < 8; c++) d.push(makeTile('flower', null, 0, null, id++));
  for (let c = 0; c < 8; c++) d.push(makeTile('joker', null, 0, null, id++));
  return d; // 152 tiles
}

export function shuffle(deck, rng) {
  const a = deck.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }
  return a;
}

export function tileKey(t) {
  if (t.type === 'suited') return t.suit + t.num;
  if (t.type === 'wind') return 'wind_' + t.honor;
  if (t.type === 'dragon') return 'dragon_' + t.honor;
  return t.type;
}

// Inverse of tileKey: build a tile from a key such as 'crak5', 'wind_east',
// 'dragon_red', 'flower', 'joker'. `id` defaults to 0; pass one to keep tiles
// distinguishable in a hand.
export function tileFromKey(key, id = 0) {
  if (key === 'flower' || key === 'joker') return makeTile(key, null, 0, null, id);
  if (key.startsWith('wind_')) return makeTile('wind', null, 0, key.slice(5), id);
  if (key.startsWith('dragon_')) return makeTile('dragon', null, 0, key.slice(7), id);
  const m = /^(crak|bam|dot)([1-9])$/.exec(key);
  if (!m) return null;
  return makeTile('suited', m[1], Number(m[2]), null, id);
}

export function tileName(t) {
  if (t.type === 'suited') return t.num + ' ' + SUIT_NAMES[t.suit];
  if (t.type === 'wind') return WIND_NAMES[t.honor] + ' Wind';
  if (t.type === 'dragon') return DRAGON_NAMES[t.honor] + ' Dragon';
  if (t.type === 'flower') return 'Flower';
  return 'Joker';
}

export function tilesMatch(a, b) {
  return tileKey(a) === tileKey(b);
}

export function sortHand(hand) {
  const order = { suited: 0, wind: 1, dragon: 2, flower: 3, joker: 4 };
  hand.sort((a, b) => {
    if (order[a.type] !== order[b.type]) return order[a.type] - order[b.type];
    if (a.type === 'suited') {
      if (a.suit !== b.suit) return SUITS.indexOf(a.suit) - SUITS.indexOf(b.suit);
      return a.num - b.num;
    }
    if (a.type === 'wind') return WINDS.indexOf(a.honor) - WINDS.indexOf(b.honor);
    if (a.type === 'dragon') return DRAGONS.indexOf(a.honor) - DRAGONS.indexOf(b.honor);
    return 0;
  });
  return hand;
}
